import { render, staticRenderFns } from "./TemplateTable.vue?vue&type=template&id=b48012da&scoped=true&"
import script from "./TemplateTable.vue?vue&type=script&lang=js&"
export * from "./TemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTable.vue?vue&type=style&index=0&id=b48012da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48012da",
  null
  
)

export default component.exports